const depreciatedFeatures = [
    // {
    //   name: "Bulk Request",
    //   routes: ["bulk-actions-log-v2", "bulk_imports_log"],
    //   enable: false,
    // },
    {
      name: "Campaigns",
      routes: ["campaigns-v2", "customer_acquisition"],
      enable: false,
    },
    {
      name: "Triggers",
      routes: ["triggers-v2", "triggers"],
      enable: false,
    },
    // {
    //   name: "HTML Builder",
    //   routes: ["marketing-v2", "email_builder_list", "email_builder_dashboard"],
    //   enable: false,
    // }
]

export default depreciatedFeatures;